export default __webpack_public_path__ + "static/media/245.b29f23fc.svg";